// extracted by mini-css-extract-plugin
module.exports = {"desktopImg":"TextItem_desktopImg__fG6fk","mobileImg":"TextItem_mobileImg__AKxRw","el":"TextItem_el__68UQr","desc":"TextItem_desc__i_T7Y"};